export default (number: number, base = 16) => {
  return `${number / base}rem`;
};

export const revertToPx = (value: string, base = 16) => {
  const rawValue = Number(value.replace('rem', ''));
  return rawValue * base;
};
